// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-wrap {
  border-bottom: 4px solid #001c44;
  border-radius: 20px 20px 0px 0px; /* Add roundness to top */
  background-color: #0e2955;
  padding-top: 17px;
  width: 1300px;
  height: 80px;
  font-size: 1.4rem;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.8);
}

@media (min-aspect-ratio: 2/1) and (max-height: 700px) {
  .toolbar-wrap {
    height: 750px;
    width: 140px;

    padding-top: unset;
    border-radius: 20px 0px 0px 20px; /* Add roundness to left side */
    border-right: 4px solid #001c44;
    border-bottom: unset;
  }
}

.toolbar {
  display: flex;

  padding: 0px 20px;
  height: 70px;
}

.toolbar.vertical {
  flex-direction: column;
  height: calc(100% - 40px);
  padding: 20px 0px;
}

.logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 60px;
}

.dropdown-wrap {
  /* border: 2px green solid; */
  display: flex;
  width: 75%;
  justify-content: space-evenly;
}

.dropdown-wrap.vertical {
  flex-direction: column;
  height: 75%;
  width: 100%;
}

.dropdown {
  /* border: 2px red solid; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.rc-menu-button {
  background-color: #0e2955;
  color: white;
  /* width: 70%; */
  height: 70%;
  font-size: 1.4rem;
}

.rc-menu-button:hover {
  background-color: #0e2955;
  /* color: #0E2955; */
  outline: none;
}

.rc-menu--open {
  background-color: #0e2955;
  color: white;
}

/* .rc-menu--open:hover {
    background-color: white;
    color: #0E2955;
} */

.rc-menu--animation .rc-menu__item {
  background-color: #0e2955;
}

.rc-menu--animation .rc-menu__item:hover {
  /* background-color: white; */
  /* color: #0E2955; */
}

.rc-menu__item:hover {
  background-color: white;
  color: #0e2955;
}

.banana-wrap {
  /* border: 2px solid orange; */
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: cursive;
  margin-left: 20px;
  font-size: 1.2rem;
}

.banana-wrap.vertical {
  margin-left: 0px;
}

.banana {
  height: 30px;
  width: 30px;
}

.banana > p {
  font: 16px;
  text-align: center;
}

.im-gabig {
  height: 60px;
  width: 60px;

  cursor: pointer;
}

.im-gabig-wrap {
  /* border: 2px solid green; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 40px;
}

.im-gabig-wrap.vertical {
  margin-left: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/Main/Components/Toolbar/Toolbar.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,gCAAgC,EAAE,yBAAyB;EAC3D,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE;IACE,aAAa;IACb,YAAY;;IAEZ,kBAAkB;IAClB,gCAAgC,EAAE,+BAA+B;IACjE,+BAA+B;IAC/B,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;;EAEb,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;;GAGG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;;EAEX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".toolbar-wrap {\n  border-bottom: 4px solid #001c44;\n  border-radius: 20px 20px 0px 0px; /* Add roundness to top */\n  background-color: #0e2955;\n  padding-top: 17px;\n  width: 1300px;\n  height: 80px;\n  font-size: 1.4rem;\n  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.8);\n}\n\n@media (min-aspect-ratio: 2/1) and (max-height: 700px) {\n  .toolbar-wrap {\n    height: 750px;\n    width: 140px;\n\n    padding-top: unset;\n    border-radius: 20px 0px 0px 20px; /* Add roundness to left side */\n    border-right: 4px solid #001c44;\n    border-bottom: unset;\n  }\n}\n\n.toolbar {\n  display: flex;\n\n  padding: 0px 20px;\n  height: 70px;\n}\n\n.toolbar.vertical {\n  flex-direction: column;\n  height: calc(100% - 40px);\n  padding: 20px 0px;\n}\n\n.logo-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.logo {\n  height: 60px;\n}\n\n.dropdown-wrap {\n  /* border: 2px green solid; */\n  display: flex;\n  width: 75%;\n  justify-content: space-evenly;\n}\n\n.dropdown-wrap.vertical {\n  flex-direction: column;\n  height: 75%;\n  width: 100%;\n}\n\n.dropdown {\n  /* border: 2px red solid; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.rc-menu-button {\n  background-color: #0e2955;\n  color: white;\n  /* width: 70%; */\n  height: 70%;\n  font-size: 1.4rem;\n}\n\n.rc-menu-button:hover {\n  background-color: #0e2955;\n  /* color: #0E2955; */\n  outline: none;\n}\n\n.rc-menu--open {\n  background-color: #0e2955;\n  color: white;\n}\n\n/* .rc-menu--open:hover {\n    background-color: white;\n    color: #0E2955;\n} */\n\n.rc-menu--animation .rc-menu__item {\n  background-color: #0e2955;\n}\n\n.rc-menu--animation .rc-menu__item:hover {\n  /* background-color: white; */\n  /* color: #0E2955; */\n}\n\n.rc-menu__item:hover {\n  background-color: white;\n  color: #0e2955;\n}\n\n.banana-wrap {\n  /* border: 2px solid orange; */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: cursive;\n  margin-left: 20px;\n  font-size: 1.2rem;\n}\n\n.banana-wrap.vertical {\n  margin-left: 0px;\n}\n\n.banana {\n  height: 30px;\n  width: 30px;\n}\n\n.banana > p {\n  font: 16px;\n  text-align: center;\n}\n\n.im-gabig {\n  height: 60px;\n  width: 60px;\n\n  cursor: pointer;\n}\n\n.im-gabig-wrap {\n  /* border: 2px solid green; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 40px;\n}\n\n.im-gabig-wrap.vertical {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
